import { render, staticRenderFns } from "./ownership.vue?vue&type=template&id=a6a62c32&scoped=true&"
import script from "./ownership.vue?vue&type=script&lang=js&"
export * from "./ownership.vue?vue&type=script&lang=js&"
import style0 from "./ownership.vue?vue&type=style&index=0&id=a6a62c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a62c32",
  null
  
)

export default component.exports